import { useQueryClient } from '@tanstack/react-query';

import { useOpenNotification } from 'utils/antd/notification-toasts';

import type { PostIntegrationBusinessUnitsUuidSetDefault200 } from 'api';
import {
  getGetIntegrationBusinessUnitsQueryKey,
  usePostIntegrationBusinessUnitsUuidSetDefault
} from 'api';

import { useOrganisationId } from 'hooks/context';

import { SET_DEFAULT_ERROR, SET_DEFAULT_SUCCESS } from './constants';

import { useBusinessUnitsListSync } from '../BusinessUnitsListSyncContext';

export const useSetDefaultBusinessUnit = () => {
  const organisationId = useOrganisationId<number>();
  const queryClient = useQueryClient();
  const openNotification = useOpenNotification();
  const { onBusinessUnitSetDefault } = useBusinessUnitsListSync();
  const setDefaultMutation = usePostIntegrationBusinessUnitsUuidSetDefault();

  const setDefault = (uuid: string, onSuccess: () => void) =>
    setDefaultMutation.mutate(
      { organisationId, uuid },
      {
        onSuccess: (
          response: PostIntegrationBusinessUnitsUuidSetDefault200
        ) => {
          queryClient.invalidateQueries({
            queryKey: getGetIntegrationBusinessUnitsQueryKey(organisationId)
          });
          onBusinessUnitSetDefault(response.data);
          openNotification({ kind: 'success', message: SET_DEFAULT_SUCCESS });
          onSuccess();
        },
        onError: () =>
          openNotification({ kind: 'error', message: SET_DEFAULT_ERROR })
      }
    );

  return { setDefault, isPending: setDefaultMutation.isPending };
};
